<template>
  <div class="container">
    <form-tag
      @bookEditEvent="submitHandler"
      name="bookForm"
      event="bookEditEvent"
    >
      <div class="row">
        <h1 class="mt-3">Agregar/Editar Producto</h1>
        <hr />

        <div>
          <div class="float-start">
            <input type="submit" class="btn btn-primary me-2" value="Guardar" />
            <router-link to="/admin/productos" class="btn btn-outline-secondary"
              >Cancelar</router-link
            >
          </div>
          <div class="float-end">
            <a
              v-if="this.product.id > 0"
              class="btn btn-danger"
              href="javascript:void(0);"
              @click="confirmDelete(this.product.id)"
            >
              Eliminar
            </a>
          </div>
        </div>

        <hr class="mt-3" />
        <div class="col">
          <div class="row">
            <div class="col-6">
              <text-input
                v-model="product.name"
                type="text"
                required="true"
                label="Name"
                name="name"
              ></text-input>

              <div>
                <MyQuillEditor v-model="product.description" />
              </div>

              <text-input
                v-model="product.price"
                type="number"
                required="true"
                label="Price"
                name="price"
              ></text-input>
              <text-input
                v-model="product.stock"
                type="stock"
                required="true"
                label="Stock"
                name="stock"
              ></text-input>
              <!-- <text-input
                v-model="product.coming_soon"
                type="stock"
                required="true"
                label="viene pronto"
                name="comming-soon"
              ></text-input> -->
              <!-- <p>Viene Pronto:</p> -->
              <div class="form-check form-switch">
                <input
                  v-model="product.coming_soon"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="switchCheckDefault"
                />
                <label class="form-check-label" for="switchCheckDefault"
                  >Viene Pronto</label
                >
              </div>
              

              <div class="container-fluid mt-2 p-0">
                <h4 class="mt-3">Agregar Categorías</h4>
                <hr />

                <!-- Selector de categorías -->
                <CategoryPicker v-model:categories="product.categories" />

                <h5 class="form-text mb-3">Categorías seleccionadas:</h5>

                <!-- Preview como etiquetas con botón de menos -->
                <div
                  v-if="product.categories && product.categories.length"
                  class="d-flex flex-wrap gap-2"
                >
                  <span
                    v-for="(c, i) in product.categories"
                    :key="(c.name || '').toLowerCase() + '-' + i"
                    :class="[
                      'badge',
                      badgeClass(i),
                      'd-inline-flex',
                      'align-items-center',
                    ]"
                  >
                    <span class="me-2">{{ c.name }}</span>

                    <!-- Botón de quitar (símbolo menos) -->
                    <button
                      type="button"
                      class="btn-close btn-close-white btn-sm"
                      aria-label="Quitar"
                      title="Quitar"
                      @click="removeAt(i)"
                    ></button>
                  </span>
                </div>
                <small v-else class="text-muted"
                  >No hay categorías seleccionadas.</small
                >

                <!-- (Opcional) JSON para depuración -->
                <details class="mt-2">
                  <summary>Ver JSON</summary>
                  <pre class="bg-light p-2 mt-2">{{ product.categories }}</pre>
                </details>
              </div>
                <hr />

              <text-input
                v-model="product.discount"
                type="stock"
                required="true"
                label="Descuento"
                name="discount"
              ></text-input>
              <text-input
                v-model="product.brand"
                type="stock"
                required="true"
                label="Marca"
                name="brand"
              ></text-input>
            </div>
            <div class="col-6">
              <!-- Imagenes -->
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h4>Portada</h4>
                {{ product.is_published }}
                 <div class="form-check form-switch">
                  <input
                    v-model="product.is_published"
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="isPublishedSwitch"
                  />
                  <label class="form-check-label" for="isPublishedSwitch"
                    >Publicado</label
                  >
                </div>

              </div>
              
              <div class="mb-3">
                <label for="formFile" class="form-label"
                  >Default file input example</label
                >
                <input class="form-control" type="file" id="formFile" />
              </div>
              <div class="row">
                <img
                  :src="product.image"
                  class="img-product"
                  alt="product image"
                />
              </div>

              <h4>Resto Imagenes</h4>
              <div class="mb-3">
                <label for="formFile" class="form-label"
                  >Default file input example</label
                >
                <input class="form-control" type="file" id="formFileResto" />
              </div>
              <div class="d-flex flex-wrap">
                <div
                  v-for="(img, index) in product.images"
                  :key="index"
                  class="thumbnail"
                >
                  <img
                    :src="img.image"
                    class="img-product p-3"
                    alt="Imagen del producto"
                  />
                  <div class="delete-image">
                    <!-- <i class="fa-solid fa-trash"></i> -->

                    <button
                      type="button"
                      class="btn btn-danger btn-sm"
                      @click="this.delete(img.id)"
                    >
                      Eliminar
                    </button>
                    <span class="visually-hidden">Delete Image</span>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <hr />

          <div class="clearfix"></div>
        </div>
      </div>
    </form-tag>
  </div>
</template>

<script>
import Security from "./security.js";
import FormTag from "@/components/forms/FormTag";
import TextInput from "@/components/forms/TextInput";
// import SelectInput from '@/components/forms/SelectInput'
import router from "@/router";
import notie from "notie";
import MyQuillEditor from "./TextEdit.vue";
import { store } from "./store.js";
import CategoryPicker from "./CategoryPicker.vue";

export default {
  name: "BookEdit",
  beforeMount() {
    Security.requireToken();

    // get book for edit if id > 0
    if (this.$route.params.productId > 0) {
      // editing a book
      fetch(
        process.env.VUE_APP_API_URL +
          "/api/product/products/inventory/" +
          this.$route.params.productId +
          "/",
        Security.requestOptions(null, "GET")
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.error) {
            this.$emit("error", data.message);
          } else {
            this.product = data;
            console.log(data);
          }
        });
    }

    // get list of authors for drop down
    fetch(
      process.env.VUE_APP_API_URL + "/admin/authors/all",
      Security.requestOptions("")
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          this.$emit("error", data.message);
        } else {
          this.authors = data.data;
        }
      });
  },
  components: {
    "form-tag": FormTag,
    "text-input": TextInput,
    MyQuillEditor,
    CategoryPicker,
    // 'select-input': SelectInput,
  },
  data() {
    return {
      product: {},
      description: "",
      store,
      book: {
        id: 0,
        title: "",
        author_id: 0,
        publication_year: null,
        description: "",
        cover: "",
        slug: "",
        genres: [],
        genre_ids: [],
      },
      authors: [],
      imgPath: process.env.VUE_APP_IMAGE_URL,
      genres: [
        { value: 1, text: "Science Fiction" },
        { value: 2, text: "Fantasy" },
        { value: 3, text: "Romance" },
        { value: 4, text: "Thriller" },
        { value: 5, text: "Mystery" },
        { value: 6, text: "Horror" },
        { value: 7, text: "Classic" },
      ],
      categories: [], // array para categorías { name }
      badgePalette: [
        'bg-primary text-white',
        'bg-success text-white',
        'bg-info text-dark',
        'bg-warning text-dark',
        'bg-danger text-white',
        'bg-secondary text-white',
        'bg-dark text-white',
      ],
    };
  },
  methods: {
    removeAt(index) {
      this.product.categories = this.product.categories.filter(
        (_, i) => i !== index
      );
    },
    badgeClass(i) {
      // Cicla colores según el índice
      return this.badgePalette[i % this.badgePalette.length];
    },

    async submitHandler() {
      try {
        const rawId = this.$route.params.productId;
        const productId = Number(rawId) || 0;
        const isUpdate = productId > 0;

        // --- Payload base ---
        const payload = {
          name: this.product.name,
          description: this.product.description,
          price: this.product.price,
          stock: this.product.stock,
          coming_soon: this.product.coming_soon,
          discount: this.product.discount,
          brand: this.product.brand,
        };

        if (
          Array.isArray(this.product.categories) &&
          this.product.categories.length
        ) {
          payload.categories = this.product.categories.map((c) =>
            typeof c === "string" ? { name: c } : c
          );
        }

        // --- Crear o actualizar ---
        let finalProductId = productId;

        if (isUpdate) {
          // PATCH /products/{id}/
          const resp = await fetch(
            `${process.env.VUE_APP_API_URL}/api/product/products/${productId}/`,
            Security.requestOptions(payload, "PATCH")
          );
          const data = await resp.json();
          if (!resp.ok || data.error) {
            this.$emit(
              "error",
              data.message || "Error al actualizar el producto"
            );
            return;
          }
        } else {
          // POST /products/
          const resp = await fetch(
            `${process.env.VUE_APP_API_URL}/api/product/products/`,
            Security.requestOptions(payload, "POST")
          );
          const data = await resp.json();
          if (!resp.ok || data.error) {
            this.$emit("error", data.message || "Error al crear el producto");
            return;
          }
          finalProductId = data.id || (data.product && data.product.id);
          if (!finalProductId) {
            this.$emit("error", "No se recibió el ID del producto creado");
            return;
          }
        }

        // --- Funciones auxiliares para subir imágenes ---
        const uploadPrincipal = async (file) => {
          const fd = new FormData();
          fd.append("image", file);
          const r = await fetch(
            `${process.env.VUE_APP_API_URL}/api/product/products/${finalProductId}/upload-image/`,
            {
              method: "POST",
              body: fd,
              headers: {
                Authorization: "Token " + store.token,
                "X-CSRFTOKEN":
                  "Kcj5YNCJxUVPihrwynqm56fySLJKImDdM87VKBIN8h4Lt1EV0Ziy6EjXVdukcQmT",
              },
            }
          );
          const j = await r.json();
          if (!r.ok || j.error)
            throw new Error(j.message || "Error al subir imagen principal");
        };

        const uploadAdicional = async (file) => {
          const fd = new FormData();
          fd.append("image", file);
          const r = await fetch(
            `${process.env.VUE_APP_API_URL}/api/product/products/${finalProductId}/add-image/`,
            {
              method: "POST",
              body: fd,
              headers: {
                Authorization: "Token " + store.token,
                "X-CSRFTOKEN":
                  "Kcj5YNCJxUVPihrwynqm56fySLJKImDdM87VKBIN8h4Lt1EV0Ziy6EjXVdukcQmT",
              },
            }
          );
          const j = await r.json();
          if (!r.ok || j.error)
            throw new Error(j.message || "Error al subir imagen adicional");
        };

        // --- Tomar archivos de los inputs (permitir múltiples) ---
        const fileInput = document.getElementById("formFile");
        const filesMain = Array.from(fileInput?.files || []);

        const fileInputResto = document.getElementById("formFileResto");
        const filesResto = Array.from(fileInputResto?.files || []);

        // --- Subida “igual que la primera” ---
        if (filesMain.length > 0) {
          // 1) Primera como principal
          await uploadPrincipal(filesMain[0]);
          // 2) Las demás como adicionales
          for (let i = 1; i < filesMain.length; i++) {
            await uploadAdicional(filesMain[i]);
          }
        }

        // 3) Todas las de formFileResto como adicionales
        for (const f of filesResto) {
          await uploadAdicional(f);
        }

        // --- Éxito ---
        this.$emit(
          "success",
          isUpdate
            ? "Cambios e imágenes guardados correctamente"
            : "Producto creado e imágenes guardadas correctamente"
        );
        this.$router.push("/admin/productos");
      } catch (error) {
        console.error(error);
        this.$emit("error", error?.message || error);
      }
    },

    loadCoverImage() {
      // get a reference to the input using ref
      const file = this.$refs.coverInput.files[0];

      // encode the file using the FileReader API
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result
          .replace("data:", "")
          .replace(/^.+,/, "");
        this.book.cover = base64String;
        // alert(base64String);
      };
      reader.readAsDataURL(file);
    },
    async confirmDelete() {
      notie.confirm({
        text: "¿Estás seguro de eliminar este producto?",
        submitText: "Eliminar",
        cancelText: "Cancelar",
        submitCallback: async () => {
          try {
            const productId = this.$route.params.productId;
            const url = `${process.env.VUE_APP_API_URL}/api/product/products/${productId}/`; // <- slash final

            const res = await fetch(url, {
              method: "DELETE",
              headers: {
                Authorization: `Token ${this.store.token}`,
                Accept: "application/json",
              },
            });

            // 204 No Content -> éxito sin cuerpo
            if (res.status === 204 || res.status === 200) {
              this.$emit("success", "Producto eliminado correctamente");
              // Ej.: redirigir o refrescar lista
              router.push("/admin/productos");
              return;
            }

            // Si el backend devolvió JSON con error
            let msg = "Error eliminando el producto";
            try {
              const data = await res.json();
              if (data?.message) msg = data.message;
            } catch (_) {
              // sin cuerpo o no JSON
            }

            this.$emit("error", `${msg} (HTTP ${res.status})`);
          } catch (err) {
            this.$emit("error", err?.message || String(err));
          }
        },
      });
    },

    obtenerHTML() {
      const html = this.$refs.quillEditor.getHTML();
      console.log(html);
    },
    delete(id) {
      console.log("Deleting image with ID:", id);
      // Implement the delete logic here
      // For example, you might want to send a request to delete the image by its ID
      fetch(
        `${process.env.VUE_APP_API_URL}/api/product/products/${this.$route.params.productId}/delete-image/${id}/`,
        {
          method: "DELETE",
          headers: {
            Authorization: "Token " + this.store.token,
            "X-CSRFTOKEN":
              "Kcj5YNCJxUVPihrwynqm56fySLJKImDdM87VKBIN8h4Lt1EV0Ziy6EjXVdukcQmT",
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.error) {
            this.$emit("error", data.message);
          } else {
            this.$emit("success", "Image deleted successfully");
            // Optionally, refresh the product images or handle UI updates
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },
    Publish(id) {
      console.log("Deleting image with ID:", id);
      // Implement the delete logic here
      // For example, you might want to send a request to delete the image by its ID
      fetch(
        `${process.env.VUE_APP_API_URL}/api/product/products/${this.$route.params.productId}/delete-image/${id}/`,
        {
          method: "DELETE",
          headers: {
            Authorization: "Token " + this.store.token,
            "X-CSRFTOKEN":
              "Kcj5YNCJxUVPihrwynqm56fySLJKImDdM87VKBIN8h4Lt1EV0Ziy6EjXVdukcQmT",
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.error) {
            this.$emit("error", data.message);
          } else {
            this.$emit("success", "Image deleted successfully");
            // Optionally, refresh the product images or handle UI updates
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },
  },
  watch: {
    async 'product.is_published'(newValue) {

      const payload = {
          "is_published": newValue
        }
      const resp = await fetch(
            `${process.env.VUE_APP_API_URL}/api/product/products/${this.product.id}/publish/`,
            Security.requestOptions(payload, "PATCH")
          );
          const data = await resp.json();
          if (!resp.ok || data.error) {
            this.$emit(
              "error",
              data.message || "Error al actualizar el producto"
            );
            return;
          }
    },
  },
};
</script>

<style scoped>
.book-cover {
  max-width: 10em;
}
.img-product {
  max-width: 100%;
  width: auto;
  height: 200px;
}

.thumbnail {
  position: relative;
  margin: 10px;
  border: 1px solid #ddd;
  padding: 5px;
  border-radius: 4px;
}

.delete-image {
  position: absolute;
  top: 0;
  /* width: 60px; */
  /* height: 60px; */
  /* background: #a95252; */
  font-size: 12px;
  right: 0;
  /* background-color: red; */
  color: black;
  /* padding: 5px; */
  cursor: pointer;
}
</style>
